import React from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import PaypalOnePay from "../components/PaypalOnePay";
import PaypalSuscription from "../components/PaypalSuscription";
import PanelLayout from "../components/PanelLayout";
import { Translate } from "react-redux-i18n";
import { connect } from "react-redux";
import "./styles/SuscriptionPayPanel.css";

const PLAN_FEATURES = {
  10: ["suscription5", "suscription2", "suscription8", "suscription3", "suscription4"],
  20: ["suscription5", "suscription7", "suscription8", "suscription3", "suscription4"],
  100: ["suscription1", "suscription2", "suscription8", "suscription3", "suscription4"],
  200: ["suscription1", "suscription7", "suscription8", "suscription3", "suscription4"],
  15: ["one_pay1", "one_pay2", "one_pay3", "one_pay4", "one_pay5"],
};

const PLAN_PERIOD = {
  10: { key: "suscription_monthly", className: "subscription-checkout-period--monthly" },
  20: { key: "suscription_monthly", className: "subscription-checkout-period--monthly" },
  100: { key: "suscription_yearly", className: "subscription-checkout-period--yearly" },
  200: { key: "suscription_yearly", className: "subscription-checkout-period--yearly" },
  15: { key: "one_pay", className: "subscription-checkout-period--onepay" },
};

function getPlanTitle(value) {
  if (value === 15) return "one_pay";
  return "suscription_mine";
}

class SuscriptionPayPanel extends React.Component {
  render() {
    const { value } = this.props;
    const features = PLAN_FEATURES[value] || [];
    const period = PLAN_PERIOD[value];
    const isOnePay = value === 15;

    return (
      <PanelLayout>
        <div className="subscription-checkout">
          <header className="subscription-checkout-header">
            <h1>
              <Translate value="kind_pay" />
            </h1>
            <p>
              <Translate value="you_cart" />
            </p>
          </header>

          <section className="subscription-checkout-card">
            <div className="subscription-checkout-card-header">
              <h2 className="subscription-checkout-card-title">
                <Translate value="you_cart" />
              </h2>
              <span className="subscription-checkout-badge">1</span>
            </div>

            <div className="subscription-checkout-plan">
              <div className="subscription-checkout-plan-top">
                <div className="subscription-checkout-plan-info">
                  {period && (
                    <span
                      className={`subscription-checkout-period ${period.className}`}
                    >
                      <Translate value={period.key} />
                    </span>
                  )}
                  <h2>
                    <Translate value={getPlanTitle(value)} />
                  </h2>
                  <ul className="subscription-checkout-features">
                    {features.map((featureKey) => (
                      <li key={featureKey}>
                        <Translate value={featureKey} />
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="subscription-checkout-price">
                  <span className="subscription-checkout-price-amount">
                    ${value}
                  </span>
                  <span className="subscription-checkout-price-currency">
                    USD
                  </span>
                </div>
              </div>
            </div>

            <div className="subscription-checkout-total">
              <span>
                <Translate value="checkout_total" />
              </span>
              <strong>${value} USD</strong>
            </div>

            <div className="subscription-checkout-promo">
              <label
                className="subscription-checkout-promo-label"
                htmlFor="promo_code_panel"
              >
                <Translate value="promo_code" />
              </label>
              <div className="subscription-checkout-promo-row">
                <input
                  id="promo_code_panel"
                  type="text"
                  className="subscription-checkout-promo-input"
                  placeholder=""
                />
                <button type="button" className="subscription-checkout-promo-btn">
                  <Translate value="password_forget_send" />
                </button>
              </div>
            </div>
          </section>

          <section className="subscription-checkout-card">
            <div className="subscription-checkout-payment">
              <h3 className="subscription-checkout-payment-title">PayPal</h3>
              <p className="subscription-checkout-payment-note">
                <Translate value="checkout_secure_note" />
              </p>
              <div className="subscription-checkout-paypal">
                {isOnePay ? <PaypalOnePay /> : <PaypalSuscription />}
              </div>
            </div>
          </section>

          <Link to="/mysuscription" className="subscription-checkout-back">
            <FaArrowLeft />
            <Translate value="suscription_mine" />
          </Link>
        </div>
      </PanelLayout>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    value: reducer.suscriptionPlan.plan_value,
  };
}

export default connect(mapStateToProps)(SuscriptionPayPanel);
